import { Suspense, lazy } from 'react';
import Styles from './withoutUrl.module.scss';
import { TextField } from '../Widgets/TextField';
import Button from '../Widgets/Button';
import { ReactComponent as HamburgerMenuSVG } from '../../imges/HamburgerMenu.svg';
import { ReactComponent as YoelloIconSVG } from '../../imges/yoelloIcon_new.svg';
import { ReactComponent as YoelloTextSVG } from '../../imges/yoelloText.svg';

import animationData from '../../lottie/data';
import { useNavigateLoggedUser } from '../../customHooks/useNavigateLoggedUser';
import PageComponent from '../Page/PageComponent';
import { useTranslation } from 'react-i18next';

const LottiePlayer = lazy(() => import('../Widgets/Lottie/LottiePlayer'));

const defaultOptions = {
    loop: true,
    play: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};

const WithoutUrl = (props) => {
    const { t } = useTranslation();
    useNavigateLoggedUser();
    return (
        <div data-component-name="WithoutUrl" className={Styles.notFoundPageContainer}>
            <header>
                <Button
                    isHeaderBtn
                    className={Styles.sidemenuToggleBtn}
                    dataComponentName={'HamburgerMenu'}
                    Icon={<HamburgerMenuSVG />}
                    onClick={props.openSideDrawer}
                />
            </header>
            <div className={Styles.wrapper}>
                <div className={Styles.yoelloIcon}>
                    <YoelloIconSVG />
                </div>

                <div className={Styles.descriptions}>
                    <TextField text={{ key: 'MainEmptyPage.WelcometoYoello' }} />
                    <TextField text={{ key: 'MainEmptyPage.NeedMarchUrl' }} />
                </div>
                <div id="ReScanQRCode" className={Styles.qrCode}>
                    <Suspense fallback={<span className="loader"></span>}>
                        <LottiePlayer
                            {...defaultOptions}
                            style={{ width: '10.625rem', height: '10.625rem' }}
                            speed={2}
                        />
                    </Suspense>
                </div>
                <div className={Styles.scanQrCode}>
                    <TextField text={{ key: 'MainEmptyPage.ScanQrCode' }} />
                </div>
            </div>

            <div className={Styles.yoelloText}>
                <YoelloTextSVG />
            </div>
            <div className={Styles.bottomText}>
                <p>{t('Misc.scanOrderPay')}</p>
            </div>
        </div>
    );
};

export default PageComponent(WithoutUrl);
